export { default } from './warning-icon';
